import { EventEmitter } from "events"
import dispatcher from "../dispatcher"

class MessageCenterStore extends EventEmitter {
	private _subTitle: string
	private _objectId: string
	private _memberAvatarUrls: string[]
	private _memberIds: string[]
	private _gigPoolId: string
	private _name: string
	private _contextDescription: string

	constructor() {
		super()
		this.setMaxListeners(0)
	}

	setContextDescription(contextDescription){
		this._contextDescription = contextDescription
	}

	getContextDescription(){
		return this._contextDescription
	}

	setGroupName(name){
		this._name = name
	}

	getGroupName(){
		return this._name
	}

	getGigPoolId(){
		return this._gigPoolId
	}

	setGigPoolId(gigPoolId){
		this._gigPoolId = gigPoolId
	}

	setAvatarUrls(memberAvatarUrls){
		this._memberAvatarUrls = memberAvatarUrls
	}

	getAvatarUrls(){
		return this._memberAvatarUrls
	}

	setSubTitle(subTitle){
		this._subTitle = subTitle
	}

	getSubTitle(){
		return this._subTitle
	}

	setObjectId(objectId){
		this._objectId = objectId
		this.emit("object_id_change")
	}

	getObjectId(){
		return this._objectId
	}


	handleActions(action) {
		switch (action.type) {
			case "XX": {
				break
			}
		}
	}
}

const  messageCenterStore = new MessageCenterStore()
dispatcher.register(messageCenterStore.handleActions.bind(messageCenterStore))
export default messageCenterStore